import { Directive, HostListener, ElementRef, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AmKeyboardService } from './am-keyboard.service';
/**
  Directiva personalizada para manejar la interacción con un teclado virtual personalizado.
  Esta directiva se activa cuando el elemento asociado recibe el foco, mostrando un teclado virtual
  personalizado según las configuraciones proporcionadas.
**/
@Directive({
  selector: '[appAmKeyboard]',
  standalone: false,
})
export class AmKeyboardDirective implements OnInit {
  /**
    El FormGroup al que pertenece el control de formulario.
    @type {UntypedFormGroup}
  **/
  @Input() currentFormGroup: UntypedFormGroup;

  /**
      Indica si se debe mostrar la navegación en el teclado virtual.
      @type {boolean}
      @default false
    **/
  @Input() showNav?: boolean = false;

  /**
      Una lista de nombres para personalizar el teclado.
      @type {string}
      @default ''
    **/
  @Input() nameList?: string = '';

  /**
      Indica si el teclado debe flotar sobre la interfaz.
      @type {boolean}
      @default true
    **/
  @Input() isFloat?: boolean = true;

  /**
      Indica si el teclado debe usar un tema oscuro.
      @type {boolean}
      @default false
    **/
  @Input() isDarkTheme?: boolean = false;

  /**
      Indica si el tema del scroll seria en blanco.
      @type {boolean}
    **/
  @Input() themeLightScroll?: boolean = false;

  /**
      Define el contenido del teclado.
      @type {string}
      @default 'keyboard-content'
    **/
  @Input() contentKeyboard?: string = 'keyboard-content';

  /**
      Control de formulario asociado al elemento del DOM.
      @type {UntypedFormControl}
      @private
    **/
  private control: UntypedFormControl;

  constructor(private el: ElementRef, private keyboardServ: AmKeyboardService) {}

  @HostListener('click') onClick() {
    if (!this.keyboardServ.keyboardRef) {
      this.showKeyboard();
    }
  }

  @HostListener('focus') onFocus() {
    this.showKeyboard();
  }

  ngOnInit() {}

  private showKeyboard() {
    this.keyboardServ.destroy();
    const inputReference = this.el.nativeElement as HTMLElement;
    const type = inputReference.getAttribute('type') || 'text';
    inputReference.classList.add('input-onfocus');
    if (this.currentFormGroup) {
      this.control =
        (this.currentFormGroup.get(inputReference.id) as UntypedFormControl) ||
        new UntypedFormControl();
    }

    if (this.control) {
      const isReadOnly = this.el.nativeElement.readOnly;
      if (!isReadOnly)
        this.keyboardServ.show(
          type,
          inputReference,
          this.control,
          this.showNav,
          this.nameList,
          this.isFloat,
          this.isDarkTheme,
          this.contentKeyboard,
          this.themeLightScroll
        );
    }

    if (type === 'checkbox' || type === 'radio') {
      this.keyboardServ.destroy(true);
    }
  }
}
